var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.computedAutomations.length
    ? _c(
        "div",
        { staticClass: "row justify-content-center align-items-center" },
        [
          _c("h5", { staticClass: "grey-text mt-3" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("automations.noAutomationsToShow")) +
                "\n  "
            ),
          ]),
        ]
      )
    : _c(
        "transition-group",
        {
          staticClass: "card-body",
          class: {
            "p-3": _vm.level === "application",
            "list-animation": _vm.level === "board",
          },
          attrs: { name: _vm.transitionByLevel, tag: "div" },
        },
        [
          _vm._l(_vm.computedAutomations, function (automation, index) {
            return [
              index != 0
                ? _c("hr", {
                    key:
                      "automation-single-separator-" +
                      _vm.level +
                      "-" +
                      (automation.id + 1),
                    staticClass: "my-2",
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(_vm.automationSingleType, {
                key:
                  "automation-single-" + _vm.level + "-" + (automation.id + 2),
                tag: "component",
                attrs: { automation: automation },
              }),
            ]
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }